import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';
import type { SerializableAuthUser } from '../interfaces/authUser';

// Auth identity (auth.user): WHO is logged in — groups, email. From Cognito session.
// User profile (RTK getUserSettings): WHAT they prefer — filters, allergies, etc.
// temporaryUser in userSlice: transient Cognito user during password reset only.

export interface AuthState {
    isLoading: boolean;
    isError: boolean;
    user?: SerializableAuthUser | null;
}

const initialState: AuthState = {
    isLoading: true,
    isError: false,
    user: undefined
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        fetchUserDataInit: (state) => {
            return {
                ...state,
                isLoading: true,
                isError: false
            };
        },
        fetchUserDataSuccess: (
            state,
            action: PayloadAction<SerializableAuthUser>
        ) => {
            return {
                ...state,
                isLoading: false,
                isError: false,
                user: action.payload
            };
        },
        fetchUserDataFailure: (state) => {
            return { ...state, isLoading: false, isError: true };
        },
        resetUserData: (state) => {
            return { ...state, isLoading: false, user: null };
        }
    }
});

export const selectAuthUser = (
    state: RootState
): SerializableAuthUser | null | undefined => state.auth.user;

export const selectAuthIsLoading = (state: RootState): boolean =>
    state.auth.isLoading;

export const {
    fetchUserDataInit,
    fetchUserDataSuccess,
    fetchUserDataFailure,
    resetUserData
} = authSlice.actions;
export default authSlice.reducer;
